<div *ngIf="selectedQuery()?.deployment_requirements?.categories?.length" id="deployment-category">
    <hyperkit-typography variant="h5">Category</hyperkit-typography>
    <hyperkit-typography variant="body1" color="secondary">{{ selectedQuery().deployment_requirements.categories.join(', ') }}</hyperkit-typography>
</div>
<div *ngIf="selectedQuery()?.deployment_requirements?.searchable_data?.length" id="searchable-data">
    <hyperkit-typography variant="h5">Searchable Data</hyperkit-typography>
    <hyperkit-typography variant="body1" color="secondary"> {{selectedQuery().deployment_requirements.searchable_data.join(', ')}} </hyperkit-typography>
</div>
<div *ngIf="selectedQuery()?.deployment_requirements?.deployment_steps?.length" id="deployment-steps">
    <hyperkit-typography variant="h5">Deployment Steps</hyperkit-typography>
    <hyperkit-markdown
    [md]="selectedQuery().deployment_requirements.deployment_steps"
  ></hyperkit-markdown>
</div>
